<template>
  <div>
    <div :class="$style.navbarWrapper">
      <div :class="$style.navbarContent">
        <div :class="$style.searchContainer">
          <div :class="$style.searchInputContainer">
            <img
              :class="$style.searchIcon"
              alt=""
              src="/static/img/SearchIcon.svg"
            />
            <div :class="$style.textContent">(Coming Soon) Search...</div>
          </div>
          <div
            :class="$style.navIconsContainer"
            v-if="userType !== 'DPE' && userType !== 'Maintenance'"
          >
            <img
              @click="goToDispatch"
              :class="$style.iconOrContainer"
              alt=""
              src="/static/img/GlobeAirplane.svg"
            />
            <!--            <div :class="$style.iconOrContainer">-->
            <!--              <img-->
            <!--                :class="$style.cloudIcon"-->
            <!--                alt=""-->
            <!--                src="/static/img/TopNavbarCloud.svg"-->
            <!--              />-->
            <!--              <div :class="$style.countWrapper">-->
            <!--                <b :class="$style.textContent">99+</b>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div :class="$style.iconOrContainer">-->
            <!--              <img :class="$style.bellIcon" alt="" src="/static/img/Bell.svg" />-->
            <!--              <div :class="$style.countWrapper">-->
            <!--                <b :class="$style.textContent">99+</b>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div :class="$style.userGreetingContainer">
            <b :class="$style.textContent">Hi, {{ user?.firstName }}!</b>
            <img
              @click="profile"
              :class="$style.userAvatar"
              alt=""
              :src="user?.image || '/static/img/Male User.svg'"
            />
          </div>
        </div>
        <!--        <div :class="$style.notificationBanner">-->
        <!--          <b :class="$style.notificationText"-->
        <!--            >You have 99+ reports that need to be reviewed</b-->
        <!--          >-->
        <!--          <img :class="$style.closeIcon" alt="" src="/static/img/white_x.svg" />-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import { useLoginStore } from "@/stores/loginStore";
import { getProcessedImageUrl } from "@/util/images";
export default {
  name: "TopNavbar",
  data() {
    return {
      user: null,
      userType: null,
    };
  },
  mounted() {
    this.user = this.useLoginStore().getUser;
    this.userType = this.useLoginStore().getUser.userType?.name;
    if (this.user.image && this.user.image !== "/static/img/Male User.svg") {
      this.user.image = getProcessedImageUrl(this.user.image);
    }
    // else {
    //   this.user.image = "/static/img/Male User.svg";
    // }
  },
  methods: {
    useLoginStore,
    profile() {
      switch (this.userType) {
        case "Instructor":
          this.$router.push({
            name: "Profile Instructor",
          });
          break;
        case "DPE":
          this.$router.push({
            name: "Profile DPE",
          });
          break;
        case "Student":
          this.$router.push({
            name: "Profile Student",
          });
          break;
        case "Maintenance":
          this.$router.push({
            name: "Profile Technician",
          });
          break;
      }
    },
    goToDispatch() {
      this.$router.push({
        name: "Dispatch",
      });
    },
  },
};
</script>
<style module scoped>
img {
  cursor: pointer;
}
.searchIcon {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}
.textContent {
  position: relative;
  line-height: 25px;
}
.searchInputContainer {
  flex: 1;
  border-radius: 26px;
  background-color: #f6f6f6;
  height: 40px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 10px;
  box-sizing: border-box;
  gap: 10px;
}
.iconOrContainer {
  width: 40px;
  position: relative;
  height: 40px;
}
.cloudIcon {
  position: absolute;
  height: 66.75%;
  width: 100%;
  top: 17.5%;
  right: 0;
  bottom: 15.75%;
  left: 0;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.countWrapper {
  position: absolute;
  height: 37.5%;
  width: 82.5%;
  top: 6.25%;
  right: -42.5%;
  bottom: 56.25%;
  left: 60%;
  border-radius: 20px;
  background-color: #ff8800;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 3px 5px;
  box-sizing: border-box;
}
.bellIcon {
  position: absolute;
  width: 73.75%;
  top: 4px;
  right: 13.14%;
  left: 13.11%;
  max-width: 100%;
  overflow: hidden;
  height: 32px;
}
.navIconsContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  font-size: 13px;
  color: #fff;
}
.userAvatar {
  width: 40px;
  position: relative;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
}
.userGreetingContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  font-size: 22px;
  color: #404040;
}
.searchContainer {
  align-self: stretch;
  background-color: #fff;
  border-bottom: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 70px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 40px 0 20px;
  gap: 50px;
}
.notificationText {
  margin: 0 auto;
}
.closeIcon {
  width: 12px;
  position: relative;
  height: 12px;
}
.notificationBanner {
  align-self: stretch;
  background-color: #ff8800;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: left;
  font-size: 15px;
  color: #fff;
  font-family: Inter, Arial, sans-serif;
}
.navbarContent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 8;
  color: rgba(64, 64, 64, 0.5);
}
.navbarWrapper {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.75);
  font-family: Helvetica, Arial, sans-serif;
}
</style>
